// extracted by mini-css-extract-plugin
export var circle = "_be-1";
export var exitConfirmationModal = "_be-5";
export var iframe = "_be-0";
export var offline = "_be-3";
export var online = "_be-2";
export var workstationSelectError = "_be-4";